import { Component, OnInit, inject } from '@angular/core';
import { TableComponent } from '../../components/table/table.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { ProcessService } from '../../services/process.service';
import { ProcessesResponse } from '../../models/processesResponse';
import { ProcessesQueryString } from '../../models/processesQueryString';
import { SearchFormComponent } from '../../components/search-form/search-form.component';

@Component({
  selector: 'hub-process',
  standalone: true,
  imports: [TableComponent, TitleComponent, SearchFormComponent],
  template: `
    <hub-title text="Processos" />
    <hub-search-form (filterEmitter)="getProcessesSearchForm($event)" />
    <hub-table
      (paginatorEmitter)="getProcessesPaginator($event)"
      [processesResponse]="processesResponse"
      [filters]="searchFormState" />
  `,
  styleUrl: './process.component.scss',
})
export class ProcessComponent implements OnInit {
  private processService = inject(ProcessService);
  public processesResponse!: ProcessesResponse;
  private paginatorFormState: ProcessesQueryString = {};
  public searchFormState: ProcessesQueryString = {};

  ngOnInit(): void {
    setTimeout(() => this.getProcesses(), 1000);
  }

  public getProcessesPaginator(query: ProcessesQueryString) {
    this.paginatorFormState = query;
    const newQuery = { ...this.searchFormState, ...query };
    this.getProcesses(newQuery);
  }

  public getProcessesSearchForm(query: ProcessesQueryString) {
    query.startDate?.setUTCHours(0);
    query.endDate?.setUTCHours(23, 59, 59, 999);
    this.searchFormState = query;
    const newQuery = { ...this.paginatorFormState, ...query };
    this.getProcesses(newQuery);
  }

  public getProcesses(query?: ProcessesQueryString) {
    if (!query)
      this.searchFormState = JSON.parse(sessionStorage.getItem('hubapi-web-process') as any) as ProcessesQueryString;

    if (this.searchFormState?.startDate) this.searchFormState.startDate = new Date(this.searchFormState.startDate);
    if (this.searchFormState?.endDate) this.searchFormState.endDate = new Date(this.searchFormState.endDate);

    this.processService.getProcesses(query ?? this.searchFormState).subscribe({
      next: response => {
        this.processesResponse = response;
        sessionStorage.removeItem('hubapi-web-process');
      },
    });
  }
}
